import { AppBar, HeaderSection, appBarCssVariables } from '@coolblue-development/freddy';
import ProfileMenu from './ProfileMenu';
import CatoLogo from './CatoLogo';
import StatusMenu from './StatusMenu';
import Username from './UserDetails';
import { useAppContext } from '../../../AppContext';
import GenerateChatButton from '../Util/GenerateChatButton';
import config from '../../../config';

export interface HeaderProps {
  instanceUrl: string;
}

const Header: React.FC<HeaderProps> = ({ instanceUrl }) => {
  const { agent } = useAppContext();
  const { environment } = config;
  const isTestingEnv = environment === 'development' || environment === 'testing';

  return (
    <AppBar
      sx={{
        '& > div': { backgroundColor: '#010040' },
        zIndex: 2,
        position: 'relative',
        ...appBarCssVariables.responsiveHeight.set('64px'),
        '& p:not(:empty)': { marginBottom: '0' }
      }}
      position="static"
      logo={<CatoLogo />}
      title="Cato"
      renderAvatar={({ size }) => (
        <HeaderSection gap={200}>
          {isTestingEnv && <GenerateChatButton />}
          {isTestingEnv && <GenerateChatButton withAttachments />}
          <StatusMenu />
          <Username name={agent?.getName() ?? ''} />
          <ProfileMenu instanceUrl={instanceUrl} avatarSize={size} />
        </HeaderSection>
      )}
    />
  );
};

export default Header;
